// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2debl","colCheckbox":"styles_colCheckbox__1gL3J"};